import { FormSwitch } from '@ipfabric/ui-components/FormSwitch/FormSwitch';
import type { FormSnippet } from '@ipfabric/ui-components/utils/formSnippets/FormSnippet';
import { z } from 'zod';
import type { DiscoverySettingsObject } from '../../model/DiscoverySettingsObject';

export type AllowTelnetFieldValues = { allowTelnet: boolean };

export const allowTelnet: FormSnippet<
  DiscoverySettingsObject,
  AllowTelnetFieldValues
> = {
  render: ({ form }) => (
    <FormSwitch
      control={form.control}
      name='allowTelnet'
      description='Allow using telnet protocol'
    />
  ), // Placeholder for the actual component
  fromModel: (model, fieldValuesDraft) => {
    fieldValuesDraft.allowTelnet = model.allowTelnet ?? false;
  },
  toModel: (transformedValues, modelDraft) => {
    modelDraft.allowTelnet = transformedValues.allowTelnet;
  },
  schema: z.object({
    allowTelnet: z.boolean(),
  }),
};
